import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ fullPage = true }) => {
  return (
    <div className={`d-flex justify-content-center align-items-center ${fullPage ? "" : "py-3"}`}
      style={{ height: fullPage ? "100vh" : "80px" }}>
      <Spinner animation="border" role="status" size={fullPage ? "md" : "sm"}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default LoadingSpinner;